import { BaseEntityConfig, WhiteListFields } from "~/redux/base-entity-config";
import { ResultImageEntity } from "~/types/models/dashboard";
import { getStyleIdFromBgAndClothing } from "~/utils/helpers";
import * as storage from "~/utils/storage";
import { DASHBOARD_STORAGE_KEYS } from "~/constants/dashboard";

class EntityConfig extends BaseEntityConfig<ResultImageEntity> {
  entityKey = "result";

  associates = [];

  whiteListFields: WhiteListFields<ResultImageEntity> = ["*"];

  getAccessors = (value: ResultImageEntity) => {
    value.$styleId = getStyleIdFromBgAndClothing(value.style.background, value.style.clothing);
    const likedPhoto = storage.load(DASHBOARD_STORAGE_KEYS.LIKED_PHOTOS) || [];
    value.$isLiked = likedPhoto.indexOf(value.id) !== -1;
  };
}

const resultImagesEntConf = new EntityConfig();

export const resultImagesSchema = resultImagesEntConf.getEntitySchema();

export default resultImagesEntConf;

export const SOURCES_RESULT_IMAGE = {
  RESULT_PAGE: "RESULT_PAGE",
};
